var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c("div", { staticClass: "details-view" }, [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          { staticClass: "tabs-container" },
          [
            _c(
              "el-tabs",
              {
                staticStyle: { width: "100%" },
                attrs: { type: "card" },
                on: { "tab-click": _vm.handleClick },
                model: {
                  value: _vm.activeTabName,
                  callback: function($$v) {
                    _vm.activeTabName = $$v
                  },
                  expression: "activeTabName"
                }
              },
              [
                _vm.$checkPermission(["module_PRQuotationFCL"])
                  ? _c(
                      "el-tab-pane",
                      {
                        key: 1,
                        attrs: { label: _vm.$t("Pricing.FCL"), name: "qutFcl" }
                      },
                      [
                        _c("quotation-list", {
                          ref: "qutFcl",
                          attrs: {
                            "quotation-type": _vm.PriceConstant.QUOTATION_FCL
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.$checkPermission(["module_PRQuotationLCL"])
                  ? _c(
                      "el-tab-pane",
                      {
                        key: 2,
                        attrs: { label: _vm.$t("Pricing.LCL"), name: "qutLcl" }
                      },
                      [
                        _c("quotation-list", {
                          ref: "qutLcl",
                          attrs: {
                            "quotation-type": _vm.PriceConstant.QUOTATION_LCL
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.$checkPermission(["module_PRQuotationAir"])
                  ? _c(
                      "el-tab-pane",
                      {
                        key: 3,
                        attrs: { label: _vm.$t("Pricing.Air"), name: "qutAir" }
                      },
                      [
                        _c("quotation-list", {
                          ref: "qutAir",
                          attrs: {
                            "quotation-type": _vm.PriceConstant.QUOTATION_AIR
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-tab-pane",
                  {
                    key: 4,
                    attrs: {
                      label: _vm.$t("CargoMsg.Cargo_PrePort"),
                      name: "prePort"
                    }
                  },
                  [
                    _c("quotation-list", {
                      ref: "prePort",
                      attrs: {
                        "quotation-type": _vm.PriceConstant.QUOTATION_PRE_PORT
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-tab-pane",
                  {
                    key: 5,
                    attrs: {
                      label: _vm.$t("CargoMsg.Cargo_FinalMile"),
                      name: "lastMile"
                    }
                  },
                  [
                    _c("quotation-list", {
                      ref: "lastMile",
                      attrs: {
                        "quotation-type": _vm.PriceConstant.QUOTATION_LAST_MILE
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }